export default "__VITE_ASSET__BoqQItDJ__"